























































import { Component, Vue } from "vue-property-decorator";
import { copyChannelGroup, getChannelGroupById } from "@/services/channels/channelGroupService";
import { ChannelGroup, CopyChannelGroup } from "@/services/channels/types";

@Component
export default class ChannelGroupCopyModal extends Vue {
    channelGroup = {} as ChannelGroup;
    model = {} as CopyChannelGroup;

    open(channelGroupId: string) {
        getChannelGroupById(channelGroupId).then(response => {
            this.channelGroup = response;
            this.model.channelGroupId = channelGroupId;
            this.model.copyChannels = false;
            this.model.name = this.channelGroup.name + " Copy";
            this.model.width = this.channelGroup.width;
            this.model.height = this.channelGroup.height;
            this.$bvModal.show("modal-channelGroupCopy");
        });
    }

    confirm() {
        this.$bvModal.hide("modal-channelGroupCopy");
        copyChannelGroup(this.model).then(() => {
            this.$emit("reload");
        });
        this.model = {} as CopyChannelGroup;
    }

    decline() {
        this.$bvModal.hide("modal-channelGroupCopy");
    }
}
